module.exports = __webpack_public_path__ + "img/mastercard@2x.a027efee.png";